export default __webpack_public_path__ + "static/media/logo.e2814576.png";